module.exports = __webpack_public_path__ + "static/img/xuanzhongwode.png@2x.4f11df84.png";